import React from 'react';
import { AlertTriangle, Mail, LogIn } from 'lucide-react';

const Maintenance = ({ message, appName, contactEmail }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center p-4">
      <div className="max-w-lg w-full text-center">
        {/* Icon */}
        <div className="w-24 h-24 bg-orange-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <AlertTriangle className="w-12 h-12 text-orange-400" />
        </div>
        
        {/* Title */}
        <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">
          Under Maintenance
        </h1>
        
        {/* Message */}
        <p className="text-gray-300 text-lg mb-8">
          {message || 'We are currently performing scheduled maintenance. Please check back soon.'}
        </p>
        
        {/* Divider */}
        <div className="border-t border-white/10 my-8"></div>
        
        {/* Contact Info */}
        {contactEmail && (
          <div className="flex items-center justify-center gap-2 text-gray-400 mb-6">
            <Mail className="w-5 h-5" />
            <span>Contact us: </span>
            <a href={`mailto:${contactEmail}`} className="text-blue-400 hover:text-blue-300">
              {contactEmail}
            </a>
          </div>
        )}
        
        {/* Admin Login Link */}
        <div className="mt-8 pt-6 border-t border-white/10">
          <p className="text-gray-500 text-sm mb-3">Administrator?</p>
          <a 
            href="/login" 
            className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/20 text-white rounded-lg transition-colors"
          >
            <LogIn className="w-4 h-4" />
            Admin Login
          </a>
        </div>
        
        {/* App Name */}
        <p className="text-gray-500 text-sm mt-8">
          © {new Date().getFullYear()} {appName || 'BettingTracker'}. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Maintenance;
